import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useObrasConcretagemFilter
 */

type State = {
  dataDe: Date | null;
  dataAte: Date | null;
  localLancamento: string | null;
  resistencia: string | null;
  nroNotaFiscal: string | null;
  statusRompimento: number | null;
  enviadoLab: number | null;
  nroLaudo: string | null;
  aprovado: number | null;
};

type Actions = {
  clearFilters: () => void;
};

export const useObrasConcretagemFilter = create<State & Actions>((set) => ({
  dataDe: null,
  dataAte: null,
  localLancamento: null,
  resistencia: null,
  nroNotaFiscal: null,
  statusRompimento: 2,
  enviadoLab: 2,
  nroLaudo: null,
  aprovado: 3,
  clearFilters: () => set({ ...initialObrasConcretagemFilters }),
}));

/**
 * initialObrasConcretagemFilters
 */

export const initialObrasConcretagemFilters: Partial<State> = {
  dataDe: null,
  dataAte: null,
  localLancamento: null,
  resistencia: null,
  nroNotaFiscal: null,
  statusRompimento: 2,
  enviadoLab: 2,
  nroLaudo: null,
  aprovado: 3,
};